import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { leadStatusFilterConfig } from '../../../configs/lead-status-filter-config';
import { LeadStatusFilterSelectedValues } from '../../../configs/lead-status-filter-config/filter-selected-values';

export const LeadStatusFilter = () => {
  return (
    <InputFilterTrigger
      renderValues={LeadStatusFilterSelectedValues}
      filterLabel='Status'
      config={leadStatusFilterConfig}
    />
  );
};
